import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { PricingValueRow } from './PricingValueRow';
import { VALUE_ROWS } from '../data/content';
type PricingCardProps = {
  showBreakdown?: boolean;
};
export function PricingCard({
  showBreakdown = true
}: PricingCardProps) {
  return <div className="overflow-hidden rounded-3xl border border-line bg-paper shadow-lift" data-id="element-140" data-mp="1i4ixe6b029p3">
      <div className="bg-night px-5 py-4 text-center" data-id="element-141" data-mp="2es70bh2hpvo2">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-amber" data-id="element-142" data-mp="29tdnzryxwaph">
          Una sola oferta · Sin planes ni extras
        </p>
        <p className="mt-1 font-display text-[19px] font-black text-canvas" data-id="element-143" data-mp="251cak2q1cdxv">
          Protocolo Energía Real™ completo
        </p>
      </div>

      {showBreakdown ? <ul className="divide-y divide-line px-5" data-id="element-144" data-mp="2xkhyixm795fu">
          {VALUE_ROWS.map(row => <PricingValueRow key={row.id} id={row.id} label={row.label} value={row.value} data-id="element-145" data-mp="2sszwe68fwyta" />)}
          <li className="flex items-center justify-between gap-4 py-3" data-id="element-146" data-mp="32km0an96kli3">
            <span className="text-[13.5px] font-extrabold uppercase tracking-wide text-night" data-id="element-147" data-mp="32mf7c3nph7qm">
              Valor total
            </span>
            <span className="font-display text-[17px] font-black text-muted line-through" data-id="element-148" data-mp="2sv2ilkx7exot">
              $67.900
            </span>
          </li>
        </ul> : <div className="flex items-center justify-center gap-2 px-5 pt-5" data-id="element-149" data-mp="2xrssfqif0x1s">
          <span className="font-display text-[20px] font-black text-muted line-through" data-id="element-150" data-mp="2jt1lqp5vudno">$67.900</span>
          <span className="rounded-full bg-flame-soft px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-flame-dark" data-id="element-151" data-mp="2otpcrau42uhw">
            −59% hoy
          </span>
        </div>}

      <div className="mt-1 border-t border-line bg-amber-soft px-5 py-6 text-center" data-id="element-152" data-mp="2evsyia5vnjfk">
        <p className="text-[11.5px] font-extrabold uppercase tracking-[0.16em] text-flame-dark" data-id="element-153" data-mp="841yf3nepw2w">
          Precio de lanzamiento
        </p>
        <p className="mt-1 font-display text-[46px] font-black leading-none text-night sm:text-[56px]" data-id="element-154" data-mp="d2llx8hnffxd">
          $27.990
          <span className="ml-1.5 align-super text-[15px] font-bold text-muted" data-id="element-155" data-mp="bjv5pl12r27v">ARS</span>
        </p>
        <p className="mt-1.5 text-[12.5px] font-semibold text-teal-700" data-id="element-156" data-mp="1o1ss0jg16pk">
          Pago único · Acceso inmediato · Es tuyo para siempre
        </p>

        <div className="mt-5" data-id="element-157" data-mp="3tt5oztdit34q">
          <CtaButton pulse href="https://librofystore.impultienda.ar/checkout" data-id="element-158" data-mp="3ttxb8dl89oic" />
        </div>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-159" data-mp="uetlgo1avd85">
          <li className="flex items-center gap-1.5 text-[11.5px] font-semibold text-teal-700" data-id="element-160" data-mp="pee9o0wo2dsa">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-161" data-mp="klcojb5v9i09" /> Garantía 7 días
          </li>
          <li className="flex items-center gap-1.5 text-[11.5px] font-semibold text-teal-700" data-id="element-162" data-mp="gl2arcbu1nau">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-163" data-mp="1d4i0t8so4l2e" /> Pago seguro
          </li>
          <li className="flex items-center gap-1.5 text-[11.5px] font-semibold text-teal-700" data-id="element-164" data-mp="18axdcaopb9hg">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-165" data-mp="2r0t4n948cptl" /> Acceso en 5 min
          </li>
        </ul>
        <p className="mt-3 text-[11.5px] text-muted" data-id="element-166" data-mp="2vyl7gy6exwck">
          Mercado Pago · Tarjeta de crédito y débito · Transferencia
        </p>
      </div>
    </div>;
}